import React, { useRef, useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import axios from "axios";
import * as XLSX from "xlsx-js-style";
import { BASE_URL } from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Download, Upload, FileSpreadsheet, Eye, Edit, Trash2, AlertCircle, CheckCircle, X, ArrowLeft, Database, Cloud, FileCheck, RefreshCw, Plus, ChevronRight, Users,
  FileText, Folder, MinusCircle, PlusCircle, Receipt, Car, Wallet, ClipboardList 
} from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { fetchBillHeaders } from "../Apis/BillHeader";
import { useNavigate } from "react-router-dom";
import '../Style/UploadMaster.css';



const UPLOAD_TYPES = [
  {
    key: "Upload MASTER",
    label: "MEMBER LIST",
    tableSuffix: "_member",
    templateName: "member",
    icon: Users,
    color: "#3b82f6"
  },
  {
    key: "Generete Bill",
    label: "BILL",
    tableSuffix: "_bill",
    templateName: "bill",
    icon: FileText,
    color: "#060808"
  },
  {
  key: "Upload RECEIPT MASTER",
  label: "RECEIPT MASTER",
  tableSuffix: "_receiptmaster",
  templateName: "receiptmaster",
  icon: ClipboardList,
  color: "#3b82f6"
}
];
const UploadMaster = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [uploadType, setUploadType] = useState("member");


  const downloadTemplate = (key) => {
  let headers = [];
  let fileName = "";

  if (key.includes("member")) {
    headers = ["Member Name", "Unit No", "Mobile", "Email"];
    fileName = "Member Master.xlsx";
  }

  else if (key.includes("bill")) {
    headers = [
      "Bill No",
      "Member Name",
      "Unit No",
      "Bill Date",
      "Due Date",
    ];
    fileName = "Master Bill.xlsx";
  }

  else if (key.includes("receipt")) {
    headers = [
      "Receipt No",
      "Bill No",
      "Unit No",
      "Receipt Date",
      "Member Name",
      "Instrument No",
      "Instrument",
      "Total Amount"
    ];
    fileName = "Receipt Master.xlsx";
  }

  const worksheet = XLSX.utils.aoa_to_sheet([headers]);

  headers.forEach((_, index) => {
    const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
    worksheet[cellRef].s = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "2563EB" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
  });

  worksheet["!cols"] = headers.map(() => ({ wch: 22 }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

  const societyName = localStorage.getItem("society") || "Society";
  XLSX.writeFile(workbook, `${societyName} ${fileName}`);
};

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, {
        type: "binary",
        cellDates: true,
      });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(
        worksheet,
        {
          defval: "",
          raw: false,
          dateNF: "dd-mm-yyyy",
        }
      );
      setExcelData(jsonData);
      setShowUploadModal(true);
    };

    reader.readAsBinaryString(file);
  };

const uploadMasterBill = async () => {
  try {
    if (!selectedFile) {
      toast.error("Please select an Excel file");
      return;
    }

    const societyName = localStorage.getItem("society");
    const token = localStorage.getItem("token");

    let tableName = "";

    if (uploadType === "member") {
      tableName = `${societyName}_member`;
    } 
    else if (uploadType === "bill") {
      tableName = `${societyName}_master_bill`;
    } 
    else if (uploadType === "receipt") {
      tableName = `${societyName}_master_receipt`;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("tableName", tableName);
    formData.append("type", uploadType);

    const response = await axios.post(
      `${BASE_URL}/bill-master/add-master-bill`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success(response.data);

    setSelectedFile(null);
    setExcelData([]);
  } catch (error) {
    console.error(error);
    toast.error(error?.response?.data || "Upload failed");
  }
};

const handleFileClick = (type) => {
  setUploadType(type);
  fileInputRef.current?.click();
};

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
        <main className="content-area">
          <SubHeader />
          <div className="dashboard-cards">
            <div className="action-card upload-card">

              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />

              <div className="card-icon">
                <Upload size={45} />
              </div>

              <h3>Upload Excel</h3>
              <p>Upload Member / Bill / Receipt master data using Excel file.</p>

              <div className="button-row">
              <button
                className="btn primary-btn"
                onClick={() => handleFileClick("bill")}
              >
                Upload Bill
              </button>

               <button className="btn download-btn"  onClick={() => downloadTemplate("bill")}>
                <Download size={18} />
                Download Template
              </button>
              </div>
            </div>

            {/* Generate Bill Card */}
            <div className="action-card bill-card">
              <div className="card-icon">
                <Receipt size={45} />
              </div>

              <h3>Generate Bill</h3>

              <p>
                Generate maintenance bills for all society members instantly.
              </p>
              <button
                className="generate-bill-btn"
                onClick={async () => {
                  try {
                    const societyName = localStorage.getItem("society");
                    const token = localStorage.getItem("token");

                    const response = await fetch(
                      `${BASE_URL}/master-bill/generate_bill?societyName=${societyName}`,
                      {
                        method: "POST",
                        headers: {
                          Authorization: `Bearer ${token}`,
                          "Content-Type": "application/json",
                        },
                      }
                    );

                    const data = await response.text();
                    console.log("Success:", data);

                  } catch (error) {
                    console.error("Error:", error);
                  }
                }}
              >
                <FileText size={18} />
                <span>Generate Bill</span>
              </button>
            </div>
            {/* ================= BILL MASTER UPLOAD CARD ================= */}
           <div className="action-card upload-card">

  <div className="card-icon">
    <Database size={45} />
  </div>

  <h3>Receipt Upload</h3>

  <p>Upload receipt Excel file for society system.</p>

  <div className="button-row">

    <button
  className="btn primary-btn"
  onClick={() => handleFileClick("receipt")}
>
  <Upload size={18} />
  Upload Receipt
</button>

    <button
      className="btn download-btn"
      onClick={() => downloadTemplate("master_receipt")}
    >
      <Download size={18} />
      Download Receipt Template
    </button>

  </div>
</div>
          </div>
          {showUploadModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "95%",
                  height: "95%",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <h2>Upload Bill Excel</h2>

                  <button
                    onClick={() => {
                      setShowUploadModal(false);
                      setSelectedFile(null);
                      setExcelData([]);
                    }}
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <X size={28} />
                  </button>
                </div>

                <p>
                  <strong>Selected File :</strong>{" "}
                  {selectedFile?.name}
                </p>

                {/* Excel Table */}
                <div
                  style={{
                    flex: 1,
                    overflow: "auto",
                    border: "1px solid #ddd",
                    marginTop: "15px",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      <tr>
                        {excelData.length > 0 &&
                          Object.keys(excelData[0]).map((header) => (
                            <th
                              key={header}
                              style={{
                                border: "1px solid #ddd",
                                padding: "10px",
                                background: "#2563eb",
                                color: "#fff",
                              }}
                            >
                              {header}
                            </th>
                          ))}
                      </tr>
                    </thead>

                    <tbody>
                      {excelData.map((row, index) => (
                        <tr key={index}>
                          {Object.values(row).map((value, i) => (
                            <td
                              key={i}
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px",
                              }}
                            >
                              {value}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Footer Buttons */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "15px",
                    marginTop: "20px",
                  }}
                >
                  <button
                    className="btn primary-btn"
                    onClick={async () => {
                      await uploadMasterBill();

                      setShowUploadModal(false);
                      setSelectedFile(null);
                      setExcelData([]);
                    }}
                  >
                    Save
                  </button>

                  <button
                    className="btn download-btn"
                    onClick={() => {
                      setShowUploadModal(false);
                      setSelectedFile(null);
                      setExcelData([]);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default UploadMaster;









